import React, { memo } from "react";
import "./ConfirmationModal.css";
import CommonButton from "../../button/CommonButton";

const ConfirmationModal = ({
  visible,
  title,
  description,
  rightButtonText,
  leftButtonText,
  onRightButtonPress,
  onLeftButtonPress,
}) => {
  if (!visible) return null;

  return (
    <div className="confirmation-modal-overlay">
      <div className="confirmation-modal-container">
        <div className="confirmation-modal-inner">
          <h2 className="confirmation-modal-title">{title}</h2>
          <p className="confirmation-modal-description">{description}</p>
          <div className="confirmation-modal-buttons">
            <CommonButton
              title={leftButtonText}
              onPress={onLeftButtonPress}
              outlined={true}
              customClassName="confirmation-modal-button"
            />
            <CommonButton
              title={rightButtonText}
              onPress={onRightButtonPress}
              customClassName="confirmation-modal-button"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ConfirmationModal);
